import { FileSource } from "@/types";

import { axios } from "../axios.instance";

export type UploadImageRequest = FormData;

export type UploadImageResponse = FileSource;

export const uploadImage = async (body: UploadImageRequest): Promise<UploadImageResponse> => {
  const { data } = await axios.post(`/files/image/upload`, body);

  return data;
};
